"use client";

import { Facebook, Instagram, Twitter, Linkedin, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer ref={ref} className={`bg-dark-background text-dark-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <nav className="flex flex-wrap items-center justify-center md:justify-start gap-6">
            <Link to="/HomePage" className="text-sm font-medium text-dark-foreground hover:text-primary active:text-primary-dark transition-colors duration-[var(--duration-fast)] relative group">
              Home
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
            </Link>
            <Link to="/#pass-the-plate-supper-club" className="text-sm font-medium text-dark-foreground hover:text-primary active:text-primary-dark transition-colors duration-[var(--duration-fast)] relative group">
              Pass the Plate
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
            </Link>
            <Link to="/#create-the-plate-cooking-classes" className="text-sm font-medium text-dark-foreground hover:text-primary active:text-primary-dark transition-colors duration-[var(--duration-fast)] relative group">
              Create the Plate
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
            </Link>
            <Link to="/#about-chef-jess" className="text-sm font-medium text-dark-foreground hover:text-primary active:text-primary-dark transition-colors duration-[var(--duration-fast)] relative group">
              About
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
            </Link>
            <Link to="/#contact" className="text-sm font-medium text-dark-foreground hover:text-primary active:text-primary-dark transition-colors duration-[var(--duration-fast)] relative group">
              Contact
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
            </Link>
          </nav>

          {}
          <div className="flex items-center gap-4">
            <Link to="#" className="text-dark-foreground hover:text-primary active:text-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="#" className="text-dark-foreground hover:text-primary active:text-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="#" className="text-dark-foreground hover:text-primary active:text-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="#" className="text-dark-foreground hover:text-primary active:text-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
            <Link to="#" className="text-dark-foreground hover:text-primary active:text-primary-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110" aria-label="Email">
              <Mail className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}